import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/store-assets/zotlo-store-logo.svg")